<div class="page-container">
  <div class="floating-tab-container">
    <div>
      <h1 style="display: inline">
        {{centro?.codigo | translate}} - {{centro?.descripcion | translate}}
      </h1>
      <div class="float-end arrows-icon">
        <mat-icon [inline]="true" (click)="backTab()">
          arrow_back_ios
        </mat-icon>
        <mat-icon
          [inline]="true"
          (click)="forwardTab()"
          *ngIf="this.tabGroup?.selectedIndex != (this.tabGroup?._tabs.length - 1)"
        >
          arrow_forward_ios
        </mat-icon>
        <mat-icon
          [inline]="true"
          (click)="saveonly()"
          *ngIf="this.centro?.edicionCentro || this.isCreating"
        >
          save
        </mat-icon>
      </div>
    </div>
    <mat-tab-group #tabGroup class="floating-tab-group">
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon
            *ngIf="validatedCentroDetailsForm == false"
            class="example-tab-icon"
            color="warn"
          >
            error_outline
          </mat-icon>
          <mat-icon
            *ngIf="validatedCentroDetailsForm == true"
            class="example-tab-icon"
            style="color: green"
          >
            check_circle_outline
          </mat-icon>
          {{ 'centro.centroData.titleGeneral' | translate}}
        </ng-template>
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 centro-card">
              <mat-card class="mat-elevation-z3 p-0 compact-card h-100">
                <mat-card-content>
                  <app-centro-details-card
                    *ngIf="centro"
                    class="h-100"
                    [centro]="centro"
                    [parent]="this"
                    [fotophotoResponsable]="this.fotophotoResponsable"
                    (detailFormComplete)="detailsFormStatus($event)"
                    (centroDetailData)="detailsFormValue($event)"
                    #CentroDetailsCardComponentRef
                  >
                  </app-centro-details-card>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon
            *ngIf="validatedUsuariosReportForm == false"
            class="example-tab-icon"
            color="warn"
          >
            error_outline
          </mat-icon>
          <mat-icon
            *ngIf="validatedUsuariosReportForm == true"
            class="example-tab-icon"
            style="color: green"
          >
            check_circle_outline
          </mat-icon>
          {{ 'centro.centroData.usersReportSostenibility' | translate}}
        </ng-template>
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 centro-card">
              <mat-card class="mat-elevation-z3 p-0 compact-card h-100">
                <mat-card-content>
                  <app-centro-user-report-card
                    *ngIf="centro && mainFormGroup"
                    class="h-100"
                    [centro]="centro"
                    [parent]="this"
                    [mainFormGroup]="mainFormGroup"
                    [fotophotoEmReporte]="this.fotophotoEmReporte"
                    [fotophotoEmAmbiental]="this.fotophotoEmAmbiental"
                    [fotophotoEmSocial]="this.fotophotoEmSocial"
                    [fotophotoEmValPrincipal]="this.fotophotoEmValPrincipal"
                    [fotophotoEmValApoyo]="this.fotophotoEmValApoyo"
                    #CentroUserReportCardComponentRef
                  >
                  </app-centro-user-report-card>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon
            *ngIf="!validatedDesignForm"
            class="example-tab-icon"
            color="warn"
          >
            error_outline
          </mat-icon>
          <mat-icon
            *ngIf="validatedDesignForm"
            class="example-tab-icon"
            style="color: green"
          >
            check_circle_outline
          </mat-icon>
          {{ 'centro.centroData.designData' | translate}}
        </ng-template>
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 centro-card">
              <mat-card class="mat-elevation-z3 p-0 compact-card h-100">
                <mat-card-content>
                  <app-centro-design-data-card
                    *ngIf="centro"
                    class="h-100"
                    [centro]="centro"
                    (designFormComplete)="designFormStatus($event)"
                    (centroDesignData)="designFormValues($event)"
                    #CentroDesignDataCardComponentRef
                  >
                  </app-centro-design-data-card>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon
            *ngIf="!validatedOperationForm"
            class="example-tab-icon"
            color="warn"
          >
            error_outline
          </mat-icon>
          <mat-icon
            *ngIf="validatedOperationForm"
            class="example-tab-icon"
            style="color: green"
          >
            check_circle_outline
          </mat-icon>
          {{ 'centro.centroData.operationData' | translate}}
        </ng-template>
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 centro-card">
              <mat-card class="mat-elevation-z3 p-0 compact-card h-100">
                <mat-card-content>
                  <app-centro-operation-data-card
                    *ngIf="centro"
                    class="h-100"
                    [centro]="centro"
                    (operationFormComplete)="operationFormStatus($event)"
                    (centroOperationData)="operationFormValues($event)"
                    #CentroOperationDataCardComponentRef
                  >
                  </app-centro-operation-data-card>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
